var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98954 0.202772C9.71917 -0.0675908 9.28083 -0.0675908 9.01046 0.202772L0.702772 8.51046C0.572939 8.6403 0.5 8.81639 0.5 9V18.6923C0.5 19.0747 0.809957 19.3846 1.19231 19.3846H7.42308C7.80543 19.3846 8.11539 19.0747 8.11539 18.6923V13.1538H10.8846V18.6923C10.8846 19.0747 11.1946 19.3846 11.5769 19.3846H17.8077C18.19 19.3846 18.5 19.0747 18.5 18.6923V9C18.5 8.81639 18.4271 8.6403 18.2972 8.51046L16.4231 6.63631V2.07692C16.4231 1.69457 16.1131 1.38462 15.7308 1.38462H14.3462C13.9638 1.38462 13.6538 1.69457 13.6538 2.07692V3.86708L9.98954 0.202772ZM1.88462 18V9.28676L9.5 1.67138L17.1154 9.28676V18H12.2692V12.4615C12.2692 12.0792 11.9593 11.7692 11.5769 11.7692H7.42308C7.04073 11.7692 6.73077 12.0792 6.73077 12.4615V18H1.88462Z",
    fill: "#5C5E69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.6a297529c8ca4a5c21d9e8d64eb2c0db.svg";
export { ForwardRef as ReactComponent };